import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxPopupModule, DxSelectBoxModule, DxButtonModule, DxToolbarModule } from 'devextreme-angular';
import { SharedModule } from '../../../../shared/shared.module';
import { LoadunitDto } from '../../../../shared/generated/backend';

@Component({
  selector: 'app-loadunit-selection-dialog',
  standalone: true,
  imports: [CommonModule, DxPopupModule, DxSelectBoxModule, DxButtonModule, DxToolbarModule, SharedModule],
  templateUrl: './loadunit-selection-dialog.component.html',
  styleUrl: './loadunit-selection-dialog.component.scss',
})
export class LoadunitSelectionDialogComponent {
  visible = input(false);
  loadunitSelection = input<LoadunitDto[]>([]);
  selectedLoadunitId = input(0);
  inAssignmentPlanningMode = input(false);
  visibleChange = output<boolean>();
  selectedLoadunitIdChange = output<number>();
  loadunitSelected = output<void>();
  restRemains = output<void>();

  get selectedLoadunit(): LoadunitDto | undefined {
    return this.loadunitSelection().find(x => x.id === this.selectedLoadunitId());
  }

  closeDialog(): void {
    this.visibleChange.emit(false);
  }

  onLoadunitChange(value: number): void {
    this.selectedLoadunitIdChange.emit(value);
  }

  handleLoadunitSelected(): void {
    this.loadunitSelected.emit();
  }

  handleRestRemains(): void {
    this.restRemains.emit();
  }
}
